import React from 'react';
import BuyGadgets from '../assets/shopService/Buy Gadgets.png';
import BuyPhone from '../assets/shopService/Buy Phone.png';
import BuySmartWatch from '../assets/shopService/Buy Smartwatches.png';
import FindNewPhone from '../assets/shopService/Find New Phone.png';
import RepairPhone from '../assets/shopService/Repair Phone.png';
import SellGammingConsole from '../assets/shopService/Sell Gaming Consoles.png';
import sellMore from '../assets/shopService/Sell More.png';
import sellSmartSpeakers from '../assets/shopService/Sell Smart Speakers.png';
import sellSmartWatch from '../assets/shopService/Sell Smartwatch.png';
import selMobile from '../assets/shopService/selMobile.png';
import { toast } from 'react-hot-toast';
import { PiChatTextDuotone } from "react-icons/pi";

const Services = [
    {
        name: "Buy Gadgets",
        image: BuyGadgets,
    },
    {
        name: "Sell Phone",
        image: selMobile,
    },
    {
        name: "Buy Phone",
        image: BuyPhone,
    },
    {
        name: "Repair Phone",
        image: RepairPhone,
    },
    {
        name: "Buy Smartwatches",
        image: BuySmartWatch,
    },
    {
        name: "Sell Smartwatches",
        image: sellSmartWatch,
    },
    {
        name: "Find New Phone",
        image: FindNewPhone,
    },
    {
        name: "Buy Smart Speakers",
        image: sellSmartSpeakers,
    },
    {
        name: "Buy Gaming Consoles",
        image: SellGammingConsole,
    },
    {
        name: "Sell More",
        image: sellMore,
    },
]

const OurService = () => {
    const handleAlert = () => {
        toast.error("The Online Services Currently Unavailable, Please visit or contact our store ");
        toast("Clear Your Queries By Chatting With Our Expert Team", {
            icon: <PiChatTextDuotone className="text-[#42C8B7]" size={24} />,
            duration: 10000,
        });
    }

    return (
        <div id="ourService" className='w-full max-w-6xl mx-auto group mb-4 mt-6 sm:mt-8 lg:mt-10 px-4 sm:px-6'>
            <h2 className='text-xl md:text-2xl font-bold text-start'>Our Service</h2>
            <div className='grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4 mb-4 mt-6 sm:mt-8 lg:mt-10'>
                {Services.map((service, index) => (
                    <div key={index} className='flex flex-col items-center '>
                        <img src={service.image} alt={service.name} className='w-32 ' onClick={handleAlert}/>
                        <h3 className=' text-xs md:text-sm font-normal md:font-semibold mt-2 text-center'>{service.name}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OurService;
